/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Join_SubmitInputs */

const en_us2_clubs_join_submit = /** @type {(inputs: Clubs_Join_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the club`)
};

const pt_br2_clubs_join_submit = /** @type {(inputs: Clubs_Join_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar no clube`)
};

const es_419_clubs_join_submit = /** @type {(inputs: Clubs_Join_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unirme al club`)
};

const pt_pt2_clubs_join_submit = /** @type {(inputs: Clubs_Join_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar no clube`)
};

const fr_fr2_clubs_join_submit = /** @type {(inputs: Clubs_Join_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoindre le club`)
};

const de_de2_clubs_join_submit = /** @type {(inputs: Clubs_Join_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dem Club beitreten`)
};

const it_it2_clubs_join_submit = /** @type {(inputs: Clubs_Join_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entra nel club`)
};

/**
* | output |
* | --- |
* | "Join the club" |
*
* @param {Clubs_Join_SubmitInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_join_submit = /** @type {((inputs?: Clubs_Join_SubmitInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Join_SubmitInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_join_submit(inputs)
	if (locale === "es-419") return es_419_clubs_join_submit(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_join_submit(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_join_submit(inputs)
	if (locale === "de-DE") return de_de2_clubs_join_submit(inputs)
	if (locale === "it-IT") return it_it2_clubs_join_submit(inputs)
	return en_us2_clubs_join_submit(inputs)
});
export { clubs_join_submit as "clubs.join_submit" }